<template>
  <view class="coupon-price {{numberDigit}} {{type}}">
    <text class="integer">{{valueObj.integer}}
    </text><text wx:if="{{valueObj.point}}" class="point">{{valueObj.point}}
    </text><text class="decimal">{{valueObj.decimal}}</text>
    <view class="desc">
      <view class="tip"> {{ tip }}  </view>
      <text class="unit">{{ couponInfo.max_benefit_capacity.unit }}</text>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { formatValue, getCouponTip } from '../../lib/utils'

createComponent({
  properties: {
    couponInfo: Object,
    type: String,
  },
  computed: {
    valueObj() {
      return formatValue(this.couponInfo.max_benefit_capacity.value)
    },
    tip() {
      return getCouponTip(this.couponInfo.type)
    },
    numberDigit() {
      if (String(this.valueObj.integer).length + String(this.valueObj.decimal).length + String(this.valueObj.point).length >= 3)
        return 'digit-3'
      else
        return ''
    },
  },
})
</script>

<style lang="stylus" scoped>
.coupon-price
  position relative
  font-size: 80rpx;
  font-family: DIN-Bold, DIN-Bold-self;
  color: #ffffff;
  // text-shadow: 1px 1px 0px #FFFFFF;
  line-height 1
  display: flex;
  align-items: center;
  justify-content: center;
  height 100%
  &.digit-3
    .point
      margin-left 0
      margin-right -8rpx
    .integer
      letter-spacing: -4rpx;
  &.popup-result
    font-size 80rpx
    &.digit-3
      font-size 76rpx
      .tip
        margin-bottom: 12rpx
    .tip
      margin-bottom: 20rpx
  .point
    margin-left -4rpx
    margin-right -14rpx
  .desc
    display flex
    flex-direction column
  .unit
    font-size: 30rpx;
    font-family: PingFang SC;
    font-weight: 800;
    color: #ffffff;
    position relative
    right: -8rpx
  .tip
    text-shadow: none
    width: 48rpx;
    height: 23rpx;
    background: #ffffff;
    border-radius: 11px 11px 11px 0px;
    box-shadow: 1px 1px 0px 0px rgba(255, 255, 255, 0.7);
    font-size: 16rpx;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #FF5340;
    text-align center
    line-height 23rpx
    margin-bottom: 24rpx
    margin-left 8rpx
</style>

<script type="application/json" lang="json">
{
  "component": true,
  "usingComponents": {}
}
</script>
